import React, { useEffect } from 'react';
import { formatDate } from '../utils/dateUtils';
import useShipDate from '../features/setting/shipDate/useShipDate';

const ShipDateDropdown = ({handleDataChange, includeDefault = false, airOnly = false, value, manage = 'auto'}) => {

  const { shipDates, getShipDates } = useShipDate({ manage });

  useEffect(() => {
    getShipDates();
  }, []);

  // Use controlled mode if value is explicitly provided, otherwise use uncontrolled mode
  const selectProps = value !== undefined 
    ? { value: value } 
    : { defaultValue: includeDefault ? "default" : "all" };

  return (
    <div className="flex space-y-2">
      <label htmlFor="select" className="text-lg text-gray-700 mt-auto">รอบเรือ</label>
      <select 
        id="select" 
        name="shipDate" 
        onChange={handleDataChange}
        className="ml-3 px-4 py-1.5 border border-gray-400 rounded-md"
        {...selectProps}
      >
        {includeDefault ? 
        <>
          <option value="" className="py-2">-- เลือกรอบเรือ --</option>
        </>
        : <>
          <option className="py-2" value='all'>ทั้งหมด</option>
          <option className="py-2" value='none'>ไม่มี</option>
        </>}
        {shipDates && shipDates
          .filter(date => airOnly ? date.isAir : true)
          .map((date, index) => (
            <option key={date.uuid} className="py-2" value={date.id}>
              {`${formatDate(date.shipDate)}${date.isAir ? ' - เครื่องบิน' : ''}${date.isAir && date.warehouseReceivingAddress ? ` [${date.warehouseReceivingAddress.addressNickName}]` : ''}`}
            </option>
          ))}
      </select>
    </div>
  )
}

export default ShipDateDropdown;
